import logger from "@next/core-logger"
import type {AxiosError} from "axios"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import {ITEMS_STRING_QUERY_STRING} from "../../config/constants"
import {devboxUrlTrimmer} from "../../utils/devboxUrlTrimmer"
import {urlSanitiser} from "../../utils/httpUrlTrimmer"

export const getProductFragmentsById = async (
    headers,
    itemsString: string,
    _apiProxyVersion: string,
    baseUrl: string,
    fullUrl?: string,
): Promise<string> => {
    try {
        const getProductsApi = ProductsApi("getProductFragmentsById")

        const urlTrimmed = devboxUrlTrimmer(fullUrl)

        const response = await axios({
            method: getProductsApi.method,
            url: `${urlSanitiser(baseUrl)}${getProductsApi.localEndpoint()}`,
            headers,
            params: {
                [ITEMS_STRING_QUERY_STRING]: itemsString,
                criteria: urlTrimmed,
            },
        })
        return response.data
    } catch (error) {
        const ex = error as AxiosError
        if (ex.response) {
            // Axios interceptors log this error already
            throw ex
        }
        logger.error(ex)
        throw ex
    }
}
